import { render, staticRenderFns } from "./sendRecord.vue?vue&type=template&id=4c5715c8&scoped=true&"
import script from "./sendRecord.vue?vue&type=script&lang=js&"
export * from "./sendRecord.vue?vue&type=script&lang=js&"
import style0 from "./sendRecord.vue?vue&type=style&index=0&id=4c5715c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5715c8",
  null
  
)

export default component.exports